var exports = {
  "kL": "x112a1f60--f478de--container",
  "wx": "x112a1f60--f478de--header",
  "M1": "x112a1f60--f478de--stats",
};

module.exports = exports;
